@if ((apps$ | async)?.length > 1) {
  <div class="relative">
    <rk-button
      icon="exchange-alt"
      [text]="'publishing.app-swap' | translate"
      (buttonClick)="onButtonClick()"
      variant="secondary"
    ></rk-button>
    @if (showList) {
      <div
        class="absolute top-12 right-0 apps-dropdown w-full max-h-[500px] overflow-auto"
        [@fadeInOut]
      >
        @for (app of apps$ | async; track app.appId) {
          <div
            class="app-option cursor-pointer px-4 py-3 truncate"
            (click)="setCurrentApp(app.appId)"
            [class.active]="app.appId === (currentAppId$ | async)"
          >
            {{ app.name }}
          </div>
        }
      </div>
    }
  </div>
}
